
import { defineComponent, onMounted, reactive, toRefs } from "vue";
import { StateType } from "./plantPlasticSource";
import { getScreenInfo } from "@/utils/util";
import Throttle from "@/utils/throttle";
import { getPlantData } from "../../../../api/production";
import { ImagePreview } from "vant";
import PreviewVideo from "@/components/previewVideo/previewVideo.vue";

let throttle: Throttle;
const states = {
  screenHeight: 0,
  farmingRecordList: [],
  id: "",
  page: 1,
  showVideos: false,
  videoUrl: "",
};
export default defineComponent({
  components: {
    PreviewVideo,
  },
  props: ["dataId"],
  setup(prop, { emit }) {
    const state = reactive<StateType>(states);
    state.screenHeight = getScreenInfo().screenHeight - 44;
    const { getPlantList } = useDatas(state, emit);
    onMounted(() => {
      state.id = prop.dataId;
      state.page = 1;
      state.farmingRecordList = [];

      getPlantList();
      throttle = new Throttle(500, () => {
        state.page++;
        getPlantList();
      });
    });
    return {
      ...toRefs(state),
      ...useEvent(state),
    };
  },
});
const useEvent = (state: StateType) => {
  const onPreviewVideo = (item: any) => {
    state.videoUrl = item;
    state.showVideos = true;
  };
  const onPreviewImg = (i: number, v: any) => {
    let arr = v.map((item: any) => {
      return item.url;
    });
    ImagePreview({
      images: arr,
      startPosition: i,
    });
  };
  const onBottom = () => {
    throttle.search(null);
  };
  return {
    onBottom,
    onPreviewImg,
    onPreviewVideo,
  };
};

const useDatas = (state: StateType, emit: any) => {
  const getPlantList = async () => {
    const result: any = await getPlantData({
      page: state.page,
      pageSize: 10,
      traceId: state.id,
    });
    if (result.data.code == 0) {
      state.farmingRecordList = state.farmingRecordList.concat(
        result.data.data.records
      );
      state.farmingRecordList = state.farmingRecordList.map((item: any) => {
        item.videoList = item.video && item.video.split(",");
        item.imgList = item.images && item.images.split(",");
        return item;
      });
    }
  };

  return {
    getPlantList,
  };
};
